"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    title: 'Olá! Confirme a sua identificação',
    callToAction: 'Confirmar identificação',
    useAnotherAccount: 'Entrar com outra conta',
    continueWithoutIdentificationButton: 'Continuar sem identificação',
    loadingText: 'Você será redirecionado em breve...',
};
